import { render, staticRenderFns } from "./EnterNumber.vue?vue&type=template&id=3132e4c6&scoped=true"
import script from "./EnterNumber.vue?vue&type=script&lang=js"
export * from "./EnterNumber.vue?vue&type=script&lang=js"
import style0 from "./EnterNumber.vue?vue&type=style&index=0&id=3132e4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132e4c6",
  null
  
)

export default component.exports